export const JOB_APPLY_ACTIONS = {
    'OPEN_APPLY_PANEL': 'open-apply-panel',
    'SAVE_JOB': 'save-job',
};
